"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schedulerSelectors = void 0;
const constants_1 = require("@/app/shared/constants");
const colors_1 = require("@/app/shared/constants/colors");
const helpers_1 = require("@/app/shared/helpers");
const utils_1 = require("@/app/shared/helpers/utils");
const labels_1 = __importDefault(require("@/app/shared/i18n/labels"));
const EmailValidator = __importStar(require("email-validator"));
const reselect_1 = require("reselect");
const constants_2 = require("./constants");
const utils_2 = require("./utils");
const selectSchedulerState = (state) => state.SUMO1_scheduler;
const selectSchedulerData = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.schedulerData);
const selectWorkspaceData = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.workspaceData);
const selectMeetingTypes = (0, reselect_1.createSelector)(selectWorkspaceData, (workspaceData) => workspaceData?.meetingTypes || []);
const selectTenantLocations = (0, reselect_1.createSelector)(selectWorkspaceData, (workspaceData) => workspaceData?.locations || []);
const selectHostSchedule = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.hostSchedule);
const selectIsSettingsOpened = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.isSettingsOpened);
const selectShowWeekends = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.showWeekends);
const selectWorkspaceId = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.workspaceId);
const selectMeetingTypeId = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.meetingTypeId);
const selectSchedulerParams = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.schedulerParams);
const selectMeetingType = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.meetingType);
const selectAvailability = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.availability);
const selectAvailabilityCustom = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.availabilityCustom);
const selectAvailabilityRange = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.availabilityRange);
const selectAvailabilityRollingWindow = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.availabilityRollingWindow);
const selectAvailabilityRollingExpiration = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.availabilityRollingExpiration);
const selectCalendarStartAt = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.calendarStartAt);
const selectCalendarFinishAt = (0, reselect_1.createSelector)(selectCalendarStartAt, (calendarStartAt) => calendarStartAt + helpers_1.time.week);
const selectHost = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.host);
const selectMainGuest = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.mainGuest);
const selectGuests = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.guests);
const selectUpsertAction = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.upsertAction);
const selectBookAction = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.bookAction);
const selectIsSchedulerDataFetching = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.isSchedulerDataFetching);
const selectIsWorkspaceDataFetching = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.isWorkspaceDataFetching);
const selectIsHostScheduleFetching = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.isHostScheduleFetching);
const selectIsError = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.error);
const selectIsHostScheduleError = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.hostScheduleError);
const selectIsCreateFetching = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.isCreateFetching);
const selectIsCreateError = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.createError);
const selectIsBookFetching = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.isBookFetching);
const selectBookError = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.bookError);
const selectHeaderTab = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.headerTab);
const selectLimit = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.limit);
const selectIsBookSuccess = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.isBookSuccess);
const selectSelectedMeetingType = (0, reselect_1.createSelector)(selectMeetingTypes, selectMeetingTypeId, (meetingTypes, meetingTypeId) => {
    if (!meetingTypeId)
        return null;
    return meetingTypes.find((mt) => mt.id === meetingTypeId) || null;
});
/**
 * Meeting Type
 */
const selectCustomName = (0, reselect_1.createSelector)(selectMeetingType, (meetingType) => meetingType.what?.customName || '');
const selectNoteFromHost = (0, reselect_1.createSelector)(selectMeetingType, (meetingType) => meetingType.what?.noteFromHost || '');
const selectDuration = (0, reselect_1.createSelector)(selectMeetingType, (meetingType) => meetingType.when?.duration);
const selectBufferBefore = (0, reselect_1.createSelector)(selectMeetingType, (meetingType) => helpers_1.bufferTimeConvert.fromStringToEnum(meetingType.when?.beforeStartTime));
const selectBufferAfter = (0, reselect_1.createSelector)(selectMeetingType, (meetingType) => helpers_1.bufferTimeConvert.fromStringToEnum(meetingType.when?.afterEndTime));
const selectBufferBeforeInMs = (0, reselect_1.createSelector)(selectMeetingType, (meetingType) => helpers_1.bufferTimeConvert.fromStringToMs(meetingType.when?.beforeStartTime));
const selectBufferAfterInMs = (0, reselect_1.createSelector)(selectMeetingType, (meetingType) => helpers_1.bufferTimeConvert.fromStringToMs(meetingType.when?.afterEndTime));
const selectBufferCustom = (0, reselect_1.createSelector)(selectBufferBefore, selectBufferAfter, selectAvailabilityCustom, helpers_1.generateBufferCustom);
const selectLocationType = (0, reselect_1.createSelector)(selectMeetingType, (meetingType) => meetingType.where?.locationTypes?.[0]);
const selectInPersonType = (0, reselect_1.createSelector)(selectMeetingType, (meetingType) => meetingType.where?.inPersonType);
const selectPhoneCallType = (0, reselect_1.createSelector)(selectMeetingType, (meetingType) => meetingType.where?.phoneCallType);
const selectVideoConferenceType = (0, reselect_1.createSelector)(selectMeetingType, (meetingType) => meetingType.where?.videoConferenceType);
const selectLocations = (0, reselect_1.createSelector)(selectMeetingType, (meetingType) => meetingType.where?.locations || []);
const selectLocation = (0, reselect_1.createSelector)(selectLocations, (locations) => locations?.[0]);
const selectCustomAddress = (0, reselect_1.createSelector)(selectMeetingType, (meetingType) => meetingType.where?.customAddress || '');
const selectCustomPhone = (0, reselect_1.createSelector)(selectMeetingType, (meetingType) => meetingType.where?.customPhone || '');
const selectCustomCountryCode = (0, reselect_1.createSelector)(selectMeetingType, (meetingType) => meetingType.where?.customCountryCode || constants_2.DEFAULT_BOOKING_PAGE.where.customCountryCode);
const selectCalendarTimezone = (0, reselect_1.createSelector)(selectMeetingType, (meetingType) => meetingType.calendar?.timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone);
/**
 * Other
 */
const selectIsSchedulerLoaded = (0, reselect_1.createSelector)(selectSchedulerData, (schedulerData) => Boolean(schedulerData));
const selectTenantId = (0, reselect_1.createSelector)(selectSchedulerData, (schedulerData) => schedulerData?.userData?.tenantId);
const selectUserId = (0, reselect_1.createSelector)(selectSchedulerData, (schedulerData) => schedulerData?.userData?.userId);
const selectAuthUser = (0, reselect_1.createSelector)(selectSchedulerData, (schedulerData) => schedulerData?.users?.find((user) => user.id === schedulerData.userData?.userId));
const selectRole = (0, reselect_1.createSelector)(selectSchedulerData, (schedulerData) => schedulerData?.role);
const selectIsCreateOnlyMyMeetingTypes = (0, reselect_1.createSelector)(selectRole, (role) => !role?.allMeetingTypes?.includes("CREATE" /* PermissionAction.CREATE */));
const selectHostUser = (0, reselect_1.createSelector)(selectSchedulerData, selectHost, (schedulerData, host) => {
    // If host is a bucket, return null as buckets don't have user profiles
    if (host && 'bucketType' in host) {
        return null;
    }
    return schedulerData?.users?.find((user) => user.id === host?.id);
});
const selectHostCountryCode = (0, reselect_1.createSelector)(selectHostUser, (host) => host?.countryCode || undefined);
const selectHostPhone = (0, reselect_1.createSelector)(selectHostUser, (host) => host?.phoneNumber || undefined);
const selectHostDefaultVideoIntegration = (0, reselect_1.createSelector)(selectHostUser, (host) => host?.defaultVideoIntegration || undefined);
const selectCalendarParameters = (0, reselect_1.createSelector)(selectCalendarStartAt, selectCalendarFinishAt, (calendarStartAt, calendarFinishAt) => ({
    start: new Date(calendarStartAt),
    end: new Date(calendarFinishAt),
    startStr: new Date(calendarStartAt).toISOString(),
    endStr: new Date(calendarFinishAt).toISOString(),
}));
const selectFilteredHostSchedule = (0, reselect_1.createSelector)(selectHostSchedule, (hostSchedule) => (0, utils_2.filterDuplicateMeetings)(hostSchedule));
const selectFilteredHostScheduleDisabled = (0, reselect_1.createSelector)(selectMeetingType, selectFilteredHostSchedule, selectCalendarParameters, (meetingType, hostSchedule, { start, end }) => {
    const now = new Date();
    const minimumNoticePeriod = meetingType?.when?.scheduleBuffer;
    const minimumNoticePeriodInMs = (0, helpers_1.convertTimeToMsWithTimeUnit)(minimumNoticePeriod?.count, minimumNoticePeriod?.timeUnit);
    const minimumNoticePeriodDate = new Date(now.getTime() + minimumNoticePeriodInMs);
    const minimumNoticePeriodRange = minimumNoticePeriodInMs
        ? [(0, utils_2.createDisabledRange)({ start: now, end: minimumNoticePeriodDate, title: labels_1.default.SCHEDULER_MINIMUM_NOTICE_PERIOD_LABEL })]
        : [];
    return [
        ...(hostSchedule?.availability
            ? [
                (0, utils_2.createDisabledRange)({ start, end: new Date(hostSchedule.availability[0]?.startsAt ?? end) }),
                ...hostSchedule.availability.flatMap((slot, index, array) => {
                    const nextSlot = array[index + 1];
                    return nextSlot ? [(0, utils_2.createDisabledRange)({ start: new Date(slot.finishesAt), end: new Date(nextSlot.startsAt) })] : [];
                }),
                (0, utils_2.createDisabledRange)({ start: new Date(hostSchedule.availability.at(-1)?.finishesAt ?? start), end }),
            ]
            : [(0, utils_2.createDisabledRange)({ start, end })]),
        ...minimumNoticePeriodRange,
    ];
});
const selectSelectedUsersColors = (0, reselect_1.createSelector)(selectHost, selectMainGuest, selectGuests, (host, mainGuest, guests) => {
    if (guests.length > constants_1.LIMIT_USERS_TO_SHOW_COLORS) {
        return null;
    }
    return {
        host: { id: host?.id, ...colors_1.HOST_COLOR },
        mainGuest: { id: mainGuest?.id, ...colors_1.MAIN_GUEST_COLOR },
        guests: guests.map((guest, index) => ({
            id: guest.id,
            borderColor: colors_1.GUEST_COLORS[index]?.borderColor ?? colors_1.FALLBACK_COLOR.borderColor,
            backgroundColor: colors_1.GUEST_COLORS[index]?.backgroundColor ?? colors_1.FALLBACK_COLOR.backgroundColor,
            textColor: colors_1.GUEST_COLORS[index]?.textColor ?? colors_1.FALLBACK_COLOR.textColor,
        })),
    };
});
const selectFilteredHostScheduleAppointments = (0, reselect_1.createSelector)(selectFilteredHostSchedule, selectSelectedUsersColors, selectGuests, (hostSchedule, userColors, guests) => {
    const meetings = hostSchedule?.meetings || [];
    if (guests.length > constants_1.LIMIT_USERS_TO_SHOW_COLORS) {
        return (0, utils_2.mergeMeetings)(meetings).map((range) => ({
            type: 'SUMO_APPOINTMENT',
            title: labels_1.default.SCHEDULER_BUSY,
            start: new Date(range.startsAt).toISOString(),
            end: new Date(range.finishesAt).toISOString(),
            borderColor: 'var(--blue-100)',
            backgroundColor: 'var(--blue-100)',
            textColor: 'var(--primary-white)',
        }));
    }
    return meetings.map((range) => ({
        type: 'SUMO_APPOINTMENT',
        title: range.title,
        start: new Date(range.startsAt).toISOString(),
        end: new Date(range.finishesAt).toISOString(),
        borderColor: (0, utils_1.getUserColor)(range.userId, userColors).borderColor,
        backgroundColor: (0, utils_1.getUserColor)(range.userId, userColors).backgroundColor,
        textColor: (0, utils_1.getUserColor)(range.userId, userColors).textColor,
    }));
});
const selectIsCustomAvailability = (0, reselect_1.createSelector)(selectAvailability, selectHeaderTab, (availability, headerTab) => availability === "CUSTOM" /* SchedulerAvailability.CUSTOM */ || headerTab === "INSTANT_MEETING" /* SchedulerHeaderTab.INSTANT_MEETING */);
const selectAvailabilityRangeStartDate = (0, reselect_1.createSelector)(selectAvailabilityRange, (availabilityRange) => availabilityRange.startDate);
const selectAvailabilityRangeStartTime = (0, reselect_1.createSelector)(selectAvailabilityRange, (availabilityRange) => availabilityRange.startTime);
const selectAvailabilityRangeEndDate = (0, reselect_1.createSelector)(selectAvailabilityRange, (availabilityRange) => availabilityRange.endDate);
const selectAvailabilityRangeEndTime = (0, reselect_1.createSelector)(selectAvailabilityRange, (availabilityRange) => availabilityRange.endTime);
const selectWorkspace = (0, reselect_1.createSelector)(selectSchedulerData, selectWorkspaceId, (schedulerData, workspaceId) => schedulerData?.workspaces?.find((ws) => ws?.id === workspaceId));
const selectMembers = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.membersData);
const selectMembersById = (0, reselect_1.createSelector)(selectMembers, (members) => members.reduce((acc, member) => {
    if (member.id) {
        acc[member.id] = member;
    }
    return acc;
}, {}));
const selectIsFetchingMembers = (0, reselect_1.createSelector)(selectSchedulerState, (scheduler) => scheduler.isFetchingMembers);
const selectSelectedMemberIds = (0, reselect_1.createSelector)(selectMainGuest, selectGuests, (mainGuest, guests) => [mainGuest, ...guests].map((guest) => guest?.id).filter(Boolean));
const selectLicense = (0, reselect_1.createSelector)(selectSchedulerData, (schedulerData) => schedulerData?.license);
const selectIsBasicLicense = (0, reselect_1.createSelector)(selectLicense, (license) => license?.plan === "BASIC" /* LicensePlan.BASIC */);
const selectIsScheduleLicense = (0, reselect_1.createSelector)(selectLicense, (license) => license?.plan === "SCHEDULE" /* LicensePlan.SCHEDULE */);
const selectIsJourneyLicense = (0, reselect_1.createSelector)(selectLicense, (license) => license?.plan === "JOURNEY" /* LicensePlan.JOURNEY */);
const selectIsEngageAiLicense = (0, reselect_1.createSelector)(selectLicense, (license) => license?.plan === "ENGAGE_AI" /* LicensePlan.ENGAGE_AI */);
const selectIsMeetLicense = (0, reselect_1.createSelector)(selectLicense, (license) => license?.plan === "MEET" /* LicensePlan.MEET */);
const selectIsChatLicense = (0, reselect_1.createSelector)(selectLicense, (license) => license?.plan === "CHAT" /* LicensePlan.CHAT */);
const selectIsCopilotLicense = (0, reselect_1.createSelector)(selectLicense, (license) => license?.plan === "COPILOT" /* LicensePlan.COPILOT */);
const selectIsOmnitoLicense = (0, reselect_1.createSelector)(selectIsMeetLicense, selectIsChatLicense, selectIsCopilotLicense, (isMeetLicense, isChatLicense, isCopilotLicense) => isMeetLicense || isChatLicense || isCopilotLicense);
const selectIsScheduleOrMoreLicense = (0, reselect_1.createSelector)(selectIsScheduleLicense, selectIsJourneyLicense, selectIsEngageAiLicense, (isScheduleLicense, isJourneyLicense, isEngageAiLicense) => isScheduleLicense || isJourneyLicense || isEngageAiLicense);
const selectIsJourneyOrEngageAiLicense = (0, reselect_1.createSelector)(selectIsJourneyLicense, selectIsEngageAiLicense, (isJourneyLicense, isEngageAiLicense) => isJourneyLicense || isEngageAiLicense);
const selectHasLocationsAccess = (0, reselect_1.createSelector)(selectIsJourneyOrEngageAiLicense, selectIsOmnitoLicense, (isJourneyOrEngageAiLicense, isOmnitoLicense) => isJourneyOrEngageAiLicense || isOmnitoLicense);
// const selectMeetingTypeWhat = createSelector(selectMeetingType, (meetingType) => meetingType.what);
// const selectIsUserRequiredHost = createSelector(
//   selectMeetingType,
//   (meetingType) => meetingType.who?.hostAssignmentMode === AssignmentMode.ROUND_ROBIN,
// );
/**
 * Validation
 */
const selectIsDurationValid = (0, reselect_1.createSelector)(selectDuration, (duration) => Boolean(duration?.count));
const selectIsCustomNameValid = (0, reselect_1.createSelector)(selectCustomName, (customName) => Boolean(customName));
const selectIsLocationsValid = (0, reselect_1.createSelector)(selectLocations, (locations) => Boolean(locations[0]));
const selectIsCustomAddressValid = (0, reselect_1.createSelector)(selectCustomAddress, (customAddress) => Boolean(customAddress));
const selectIsCustomPhoneValid = (0, reselect_1.createSelector)(selectCustomPhone, (customPhone) => (0, utils_2.validatePhoneNumber)(customPhone));
const selectIsStartDateValid = (0, reselect_1.createSelector)(selectAvailabilityRangeStartDate, (startDate) => Boolean(startDate));
const selectIsStartTimeValid = (0, reselect_1.createSelector)(selectAvailabilityRangeStartTime, (startTime) => Boolean(startTime));
const selectIsEndDateValid = (0, reselect_1.createSelector)(selectAvailabilityRangeStartDate, selectAvailabilityRangeEndDate, (startDate, endDate) => (0, utils_2.validateEndDate)(startDate, endDate));
const selectIsEndTimeValid = (0, reselect_1.createSelector)(selectAvailabilityRangeStartTime, selectAvailabilityRangeEndTime, (startTime, endTime) => (0, utils_2.validateEndTime)(startTime, endTime));
const selectIsHostValid = (0, reselect_1.createSelector)(selectHost, (host) => Boolean(host));
const selectIsMainGuestValid = (0, reselect_1.createSelector)(selectMainGuest, (mainGuest) => {
    if (mainGuest?.subType === "TEAM" /* MemberSubType.TEAM */)
        return Boolean(mainGuest);
    return EmailValidator.validate(mainGuest?.email || '');
});
const selectIsCalendarValid = (0, reselect_1.createSelector)(selectAvailability, selectAvailabilityCustom, selectHeaderTab, (availability, availabilityCustom, headerTab) => {
    switch (headerTab) {
        case "INSTANT_MEETING" /* SchedulerHeaderTab.INSTANT_MEETING */:
            return Boolean(availabilityCustom[0]);
        case "OFFER_BOOKING_TIME" /* SchedulerHeaderTab.OFFER_BOOKING_TIME */:
            if (availability === "CUSTOM" /* SchedulerAvailability.CUSTOM */) {
                return Boolean(availabilityCustom[0]);
            }
            return true;
        default:
            return false;
    }
});
const selectAction = (0, reselect_1.createSelector)(selectUpsertAction, selectBookAction, (upsertAction, bookAction) => Boolean(upsertAction || bookAction));
const selectShowDurationError = (0, reselect_1.createSelector)(selectAction, selectIsDurationValid, (action, isvalid) => action && !isvalid);
const selectShowCustomNameError = (0, reselect_1.createSelector)(selectAction, selectIsCustomNameValid, (action, isvalid) => action && !isvalid);
const selectShowLocationsError = (0, reselect_1.createSelector)(selectAction, selectIsLocationsValid, (action, isvalid) => action && !isvalid);
const selectShowCustomAddressError = (0, reselect_1.createSelector)(selectAction, selectIsCustomAddressValid, (action, isvalid) => action && !isvalid);
const selectShowCustomPhoneError = (0, reselect_1.createSelector)(selectAction, selectIsCustomPhoneValid, (action, isvalid) => action && !isvalid);
const selectShowStartDateError = (0, reselect_1.createSelector)(selectAction, selectIsStartDateValid, (action, isvalid) => action && !isvalid);
const selectShowStartTimeError = (0, reselect_1.createSelector)(selectAction, selectIsStartTimeValid, (action, isvalid) => action && !isvalid);
const selectShowEndDateError = (0, reselect_1.createSelector)(selectAction, selectIsEndDateValid, (action, isvalid) => action && !isvalid);
const selectShowEndTimeError = (0, reselect_1.createSelector)(selectAction, selectIsEndTimeValid, (action, isvalid) => action && !isvalid);
const selectShowHostError = (0, reselect_1.createSelector)(selectAction, selectIsHostValid, (action, isvalid) => action && !isvalid);
const selectShowMainGuestError = (0, reselect_1.createSelector)(selectAction, selectIsMainGuestValid, (action, isvalid) => action && !isvalid);
const selectShowCalendarError = (0, reselect_1.createSelector)(selectAction, selectIsCalendarValid, (action, isvalid) => action && !isvalid);
const selectIsValidForSave = (0, reselect_1.createSelector)(selectIsDurationValid, selectIsCustomNameValid, selectIsLocationsValid, selectIsCustomAddressValid, selectIsCustomPhoneValid, selectIsStartDateValid, selectIsStartTimeValid, selectIsEndDateValid, selectIsEndTimeValid, selectIsHostValid, selectIsMainGuestValid, selectIsCalendarValid, selectLocationType, selectInPersonType, selectPhoneCallType, selectAvailability, (isDurationValid, isCustomNameValid, isLocationsValid, isCustomAddressValid, isCustomPhoneValid, isStartDateValid, isStartTimeValid, isEndDateValid, isEndTimeValid, isHostValid, isMainGuestValid, isCalendarValid, locationType, inPersonType, phoneCallType, availability) => isDurationValid &&
    isCustomNameValid &&
    (locationType !== "IN_PERSON" /* SchedulerLocationTab.IN_PERSON */ || inPersonType !== constants_1.InPersonType.LOCATION || isLocationsValid) &&
    (locationType !== "IN_PERSON" /* SchedulerLocationTab.IN_PERSON */ || inPersonType !== constants_1.InPersonType.CUSTOM_ADDRESS || isCustomAddressValid) &&
    (locationType !== "PHONE_CALL" /* SchedulerLocationTab.PHONE_CALL */ || phoneCallType !== constants_1.PhoneCallType.CUSTOM_PHONE || isCustomPhoneValid) &&
    (availability !== "RANGE" /* SchedulerAvailability.RANGE */ || (isStartDateValid && isStartTimeValid && isEndDateValid && isEndTimeValid)) &&
    isHostValid &&
    isMainGuestValid &&
    isCalendarValid);
/**
 * Options
 */
const selectHostVideoIntegrationOptions = (0, reselect_1.createSelector)(selectHostUser, (host) => constants_2.VIDEO_INTEGRATION_OPTIONS.filter((option) => host?.integrations?.map((integration) => integration.type).includes(option.value)));
const selectWorkspaceOptions = (0, reselect_1.createSelector)(selectSchedulerData, selectAuthUser, (schedulerData, authUser) => schedulerData?.workspaces
    ?.filter((workspace) => workspace?.id && authUser?.workspaceIds?.includes(workspace.id))
    ?.map((workspace) => ({
    id: workspace?.id,
    name: workspace?.name,
    style: workspace?.style,
    labels: workspace?.labels,
}))
    .map((workspace) => ({
    value: workspace?.id || '',
    label: workspace?.name || '',
})) || []);
const selectIsShowAvailability = (0, reselect_1.createSelector)(selectHeaderTab, (headerTab) => headerTab === "OFFER_BOOKING_TIME" /* SchedulerHeaderTab.OFFER_BOOKING_TIME */);
const selectIsShowLimit = (0, reselect_1.createSelector)(selectHeaderTab, (headerTab) => headerTab === "OFFER_BOOKING_TIME" /* SchedulerHeaderTab.OFFER_BOOKING_TIME */);
const selectLocationItems = (0, reselect_1.createSelector)(selectTenantLocations, (locations) => {
    const activeLocations = locations.filter((location) => location.active) || [];
    return activeLocations.map((location) => ({
        value: location.id,
        label: location.name || '',
    }));
});
const selectActiveWorkspaceUsers = (0, reselect_1.createSelector)(selectSchedulerData, selectWorkspaceId, (schedulerData, workspaceId) => schedulerData?.users?.filter((user) => user.status === "ACTIVE" /* UserStatus.ACTIVE */ && user.workspaceIds?.includes(workspaceId)) || []);
const selectBucketHostOptions = (0, reselect_1.createSelector)(selectSelectedMeetingType, selectMembersById, (selectedMeetingType, membersById) => {
    if (!selectedMeetingType) {
        return [];
    }
    const bucketOptions = [];
    let poolCounter = 1;
    // Process the selected meeting's who.guestsBuckets
    selectedMeetingType.who?.guestsBuckets?.forEach((bucket) => {
        if (bucket?.bucketType === constants_2.STANDARD_BUCKET_TYPE) {
            // Add first member
            const firstMemberId = bucket.members?.[0]?.id;
            const member = (firstMemberId && membersById[firstMemberId]) || null;
            if (member) {
                bucketOptions.push(member);
            }
        }
        else {
            // Convert round robin bucket to SchedulerBucketLocal
            const bucketName = `${labels_1.default.SCHEDULER_POOL_LABEL} ${poolCounter++}`;
            const schedulerBucket = bucket && (0, utils_2.convertGuestBucketToSchedulerBucketLocal)(bucket, bucketName);
            if (schedulerBucket) {
                bucketOptions.push(schedulerBucket);
            }
        }
    });
    // Add members from managedAllowedHosts if type is WHO_SECTION_AND_ADDED_USERS_OR_TEAMS
    if (selectedMeetingType.managedAllowedHosts?.enabled && selectedMeetingType.managedAllowedHosts?.type === constants_2.ALLOWED_HOSTS_TYPE) {
        selectedMeetingType.managedAllowedHosts.members?.forEach((member) => {
            if (member?.id) {
                const memberData = membersById[member.id];
                if (memberData) {
                    bucketOptions.push(memberData);
                }
            }
        });
    }
    return bucketOptions;
});
const selectHostOptions = (0, reselect_1.createSelector)(selectUserId, selectWorkspaceId, selectIsCreateOnlyMyMeetingTypes, selectActiveWorkspaceUsers, selectIsEngageAiLicense, selectIsOmnitoLicense, selectIsScheduleOrMoreLicense, selectBucketHostOptions, selectMainGuest, selectGuests, selectMembers, (userId, workspaceId, isCreateOnlyMyMeetingTypes, activeWorkspaceUsers, isEngageAiLicense, isOmnitoLicense, isScheduleOrMoreLicense, bucketHostOptions, mainGuest, guests, members = []) => {
    let hostOptions = [];
    if (isCreateOnlyMyMeetingTypes) {
        hostOptions = activeWorkspaceUsers?.filter((user) => user.id === userId);
    }
    else if (bucketHostOptions.length > 0) {
        // If bucket options exist, use them
        hostOptions = bucketHostOptions;
    }
    else {
        let activeTeams = [];
        if (isScheduleOrMoreLicense || isOmnitoLicense) {
            activeTeams = members.filter((member) => workspaceId &&
                member.workspaceIds?.includes(workspaceId) &&
                member.active &&
                member.subType === "TEAM" /* MemberSubType.TEAM */ &&
                (isEngageAiLicense || isOmnitoLicense || (members.length || 0) <= constants_1.NON_AI_ENGAGE_TEAM_MEMBERS_LIMIT));
        }
        // Otherwise, use all active users and teams
        hostOptions = [...activeWorkspaceUsers, ...activeTeams];
    }
    return hostOptions.filter((option) => {
        // Filter out main guest
        if (option.email && mainGuest?.email === option.email)
            return false;
        // Filter out guests
        if (guests.some((guest) => option.id === guest.id)) {
            return false;
        }
        return true;
    });
});
const selectActiveMembers = (0, reselect_1.createSelector)(selectMembers, selectWorkspaceId, (members, workspaceId) => members.filter((member) => member.type !== "SUMO1" /* MemberType.SUMO1 */ || member.workspaceIds?.includes(workspaceId)));
const selectAvailableGuestMembers = (0, reselect_1.createSelector)(selectActiveMembers, selectBucketHostOptions, (members, bucketOptions) => {
    if (bucketOptions.length > 0) {
        // If bucket options exist, combine all bucket options with non-SUMO1 members
        const nonSumo1Members = members.filter((member) => member.type !== "SUMO1" /* MemberType.SUMO1 */);
        return [...bucketOptions, ...nonSumo1Members];
    }
    // If no bucket options, use all members
    return members;
});
const selectGuestOptions = (0, reselect_1.createSelector)(selectAvailableGuestMembers, selectHost, (members, host) => members.filter((member) => {
    // Filter out host
    if (host?.id && host.id === member.id)
        return false;
    return true;
}));
/**
 * Saga requests
 */
const selectFinalInputFields = (0, reselect_1.createSelector)(selectMeetingType, selectMainGuest, selectHeaderTab, (meetingType, mainGuest, headerTab) => {
    const hasLocationInput = meetingType.where?.defaultLocationType === "IN_PERSON" /* SchedulerLocationTab.IN_PERSON */ &&
        meetingType.where?.inPersonType === constants_1.InPersonType.INVITEE_LOCATION;
    const hasPhoneInput = meetingType.where?.defaultLocationType === "PHONE_CALL" /* SchedulerLocationTab.PHONE_CALL */ &&
        meetingType.where?.phoneCallType === constants_1.PhoneCallType.PROMPT_INVITE;
    let nameValue = mainGuest?.name;
    if (!nameValue && headerTab === "INSTANT_MEETING" /* SchedulerHeaderTab.INSTANT_MEETING */) {
        nameValue = mainGuest?.email;
    }
    const defaultFields = (0, utils_2.getDefaultFields)(nameValue, mainGuest?.email, hasLocationInput || hasPhoneInput);
    if (hasLocationInput) {
        return [...defaultFields, (0, utils_2.getLocationField)()];
    }
    if (hasPhoneInput) {
        return [...defaultFields, (0, utils_2.getPhoneField)()];
    }
    return defaultFields;
});
const selectFinalAvailabilityData = (0, reselect_1.createSelector)(selectAvailability, selectAvailabilityCustom, selectAvailabilityRange, selectAvailabilityRollingWindow, selectAvailabilityRollingExpiration, utils_2.getAvailabilityData);
const selectFinalMeetingType = (0, reselect_1.createSelector)(selectMeetingType, selectAvailability, selectAvailabilityRollingWindow, selectLimit, selectHost, selectMainGuest, selectGuests, selectCalendarFinishAt, selectWorkspace, selectTenantId, selectAuthUser, (meetingType, availability, availabilityRollingWindow, limit, host, mainGuest, guests, calendarFinishAt, workspace, tenantId, authUser) => {
    const existingInPersonTypes = meetingType.where?.inPersonTypes;
    const hasInPersonTypes = existingInPersonTypes && existingInPersonTypes.length > 0;
    return {
        ...meetingType,
        tenantId: tenantId,
        workspaceId: workspace?.id,
        createdBy: authUser?.id,
        labels: workspace?.labels,
        style: workspace?.style,
        notifications: meetingType.notifications,
        confirmationsPage: meetingType.confirmationsPage,
        guestsLimit: limit === "UNLIMITED" /* SchedulerLimit.UNLIMITED */ ? undefined : parseInt(limit.replace('LIMIT', '')),
        what: {
            ...meetingType.what,
        },
        who: {
            ...meetingType.who,
            generalBucketType: constants_2.STANDARD_BUCKET_TYPE,
            guestsBuckets: (0, utils_2.convertMembersToBuckets)(host, guests),
            mainGuest: (0, utils_2.transformMemberOrTeam)(mainGuest),
        },
        where: {
            ...meetingType.where,
            inPersonTypes: hasInPersonTypes
                ? existingInPersonTypes
                : meetingType.where?.inPersonType
                    ? [meetingType.where.inPersonType]
                    : [],
        },
        when: {
            ...meetingType.when,
            dateRange: (0, utils_2.getDateRange)({ availability, availabilityRollingWindow, calendarFinishAt }),
        },
    };
});
const selectHostScheduleRequest = (0, reselect_1.createSelector)(selectFinalMeetingType, selectCalendarStartAt, selectCalendarFinishAt, (meetingType, startAt, finishAt) => ({
    meetingType,
    startAt,
    finishAt,
}));
const selectInboxMeetingTypeRequest = (0, reselect_1.createSelector)(selectFinalMeetingType, selectFinalAvailabilityData, selectFinalInputFields, selectCalendarParameters, (meetingType, availabilityData, inputFields, calendarParameters) => ({
    meetingType: {
        ...meetingType,
        inputFields,
        when: { ...meetingType.when, ...availabilityData },
    },
    startTime: calendarParameters.start.getTime(),
    endTime: calendarParameters.end.getTime(),
    dayLimit: constants_1.INBOX_DAY_LIMIT,
    spotLimit: constants_1.INBOX_SPOTS_LIMIT,
}));
const selectMyMeetingTypes = (0, reselect_1.createSelector)(selectMeetingTypes, selectUserId, (meetingTypes, userId) => meetingTypes
    .filter((meeting) => meeting.createdBy === userId)
    .sort((a, b) => {
    if (!a.what?.customName || !b.what?.customName)
        return 0;
    return a.what?.customName.localeCompare(b.what?.customName);
}));
const selectSharedMeetingTypes = (0, reselect_1.createSelector)(selectMeetingTypes, selectUserId, (meetingTypes, userId) => meetingTypes
    .filter((meeting) => meeting.createdBy !== userId &&
    (meeting.sharedUserId === userId ||
        meeting.who?.guestsBuckets?.some((bucket) => bucket?.members?.some((member) => member?.id === userId))))
    .sort((a, b) => {
    if (!a.what?.customName || !b.what?.customName)
        return 0;
    return a.what?.customName.localeCompare(b.what?.customName);
}));
const selectMyMeetingTypeOptions = (0, reselect_1.createSelector)(selectMyMeetingTypes, (meetingTypes) => meetingTypes.map((meetingType) => ({
    value: meetingType.id || '',
    label: meetingType.what?.customName || '',
    isManaged: !!meetingType.managedMeetingId,
})));
const selectSharedMeetingTypeOptions = (0, reselect_1.createSelector)(selectSharedMeetingTypes, (sharedMeetingTypes) => sharedMeetingTypes.map((meetingType) => ({
    value: meetingType.id || '',
    label: meetingType.what?.customName || '',
    isManaged: !!meetingType.managedMeetingId,
})));
const selectMeetingTypeDropdownOptions = (0, reselect_1.createSelector)(selectMyMeetingTypeOptions, selectSharedMeetingTypeOptions, (myMeetingOptions, sharedMeetingOptions) => {
    const options = [];
    if (myMeetingOptions.length > 0) {
        options.push({
            label: labels_1.default.SCHEDULER_MY_MEETINGS_LABEL,
            items: myMeetingOptions,
        });
    }
    if (sharedMeetingOptions.length > 0) {
        options.push({
            label: labels_1.default.SCHEDULER_SHARED_MEETINGS_LABEL,
            items: sharedMeetingOptions,
        });
    }
    return options;
});
const selectShowMeetingTypeSearch = (0, reselect_1.createSelector)(selectMyMeetingTypeOptions, selectSharedMeetingTypeOptions, (myMeetingOptions, sharedMeetingOptions) => myMeetingOptions.length + sharedMeetingOptions.length >= constants_1.MIN_ITEMS_TO_SEARCH);
const selectCreateInstantEventPayload = (0, reselect_1.createSelector)(selectWorkspaceId, selectTenantId, selectUserId, selectFinalMeetingType, selectAvailabilityCustom, selectCalendarTimezone, selectLocationType, selectFinalInputFields, selectInPersonType, selectTenantLocations, selectLocation, (workspaceId, tenantId, userId, meetingType, customAvailability, calendarTimezone, locationType, inputFields, inPersonType, locations, locationId) => ({
    event: {
        event: {
            workspaceId: workspaceId || '',
            tenantId: tenantId || '',
            userId: userId || '',
            startTime: customAvailability[0]?.start || '',
            endTime: customAvailability[0]?.end || '',
            timeZone: calendarTimezone,
            location: {
                type: locationType || "IN_PERSON" /* SchedulerLocationTab.IN_PERSON */,
                ...(locationType === "IN_PERSON" /* SchedulerLocationTab.IN_PERSON */ && inPersonType === constants_1.InPersonType.LOCATION
                    ? { settings: locationId, address: locations.find((l) => l.id === locationId)?.address }
                    : {}),
            },
            inputFields,
            note: '',
            guestEmails: [],
        },
    },
    meetingType: {
        meetingType,
        dayLimit: constants_1.INBOX_DAY_LIMIT,
        spotLimit: constants_1.INBOX_SPOTS_LIMIT,
    },
}));
exports.schedulerSelectors = {
    selectSchedulerData,
    selectWorkspaceData,
    selectHostSchedule,
    selectIsSettingsOpened,
    selectShowWeekends,
    selectAvailabilityCustom,
    selectBufferCustom,
    selectWorkspaceId,
    selectMeetingTypeId,
    selectSelectedMeetingType,
    selectSchedulerParams,
    selectMeetingType,
    selectFinalMeetingType,
    selectAvailability,
    selectAvailabilityRollingWindow,
    selectAvailabilityRollingExpiration,
    selectLimit,
    selectCalendarStartAt,
    selectCalendarTimezone,
    selectHost,
    selectMainGuest,
    selectGuests,
    selectUpsertAction,
    selectBookAction,
    selectIsSchedulerDataFetching,
    selectIsWorkspaceDataFetching,
    selectIsHostScheduleFetching,
    selectIsError,
    selectIsHostScheduleError,
    selectIsCreateFetching,
    selectIsCreateError,
    selectIsBookFetching,
    selectBookError,
    selectHeaderTab,
    selectCreateInstantEventPayload,
    selectIsShowAvailability,
    selectIsShowLimit,
    selectIsBookSuccess,
    selectIsDurationValid,
    selectIsCustomNameValid,
    selectIsCustomAddressValid,
    selectIsCustomPhoneValid,
    selectIsStartDateValid,
    selectIsStartTimeValid,
    selectIsEndDateValid,
    selectIsEndTimeValid,
    selectIsHostValid,
    selectIsMainGuestValid,
    selectIsCalendarValid,
    selectCustomName,
    selectNoteFromHost,
    selectDuration,
    selectBufferBefore,
    selectBufferAfter,
    selectBufferBeforeInMs,
    selectBufferAfterInMs,
    selectLocationType,
    selectInPersonType,
    selectPhoneCallType,
    selectVideoConferenceType,
    selectLocations,
    selectLocation,
    selectCustomAddress,
    selectCustomPhone,
    selectCustomCountryCode,
    selectIsSchedulerLoaded,
    selectHostCountryCode,
    selectHostPhone,
    selectHostDefaultVideoIntegration,
    selectCalendarParameters,
    selectFilteredHostSchedule,
    selectFilteredHostScheduleDisabled,
    selectFilteredHostScheduleAppointments,
    selectIsCustomAvailability,
    selectAvailabilityRangeStartDate,
    selectAvailabilityRangeStartTime,
    selectAvailabilityRangeEndDate,
    selectAvailabilityRangeEndTime,
    selectMembers,
    selectMembersById,
    selectSelectedMemberIds,
    selectSelectedUsersColors,
    selectMeetingTypes,
    selectMyMeetingTypes,
    selectMyMeetingTypeOptions,
    selectSharedMeetingTypes,
    selectSharedMeetingTypeOptions,
    selectMeetingTypeDropdownOptions,
    selectShowMeetingTypeSearch,
    selectHostVideoIntegrationOptions,
    selectWorkspaceOptions,
    selectLocationItems,
    selectActiveWorkspaceUsers,
    selectBucketHostOptions,
    selectHostOptions,
    selectAvailableGuestMembers,
    selectGuestOptions,
    selectHostScheduleRequest,
    selectInboxMeetingTypeRequest,
    selectIsBasicLicense,
    selectIsEngageAiLicense,
    selectIsMeetLicense,
    selectIsChatLicense,
    selectIsCopilotLicense,
    selectIsOmnitoLicense,
    selectIsScheduleOrMoreLicense,
    selectIsJourneyOrEngageAiLicense,
    selectHasLocationsAccess,
    selectIsFetchingMembers,
    selectShowDurationError,
    selectShowCustomNameError,
    selectShowLocationsError,
    selectShowCustomAddressError,
    selectShowCustomPhoneError,
    selectShowStartDateError,
    selectShowStartTimeError,
    selectShowEndDateError,
    selectShowEndTimeError,
    selectShowHostError,
    selectShowMainGuestError,
    selectShowCalendarError,
    selectIsValidForSave,
};
